import { styled } from '@linaria/react';
import { bodyFont, fonts, layout, primitives, semantic, size, space } from '../../theme/tokens';

export const FooterBar = styled.footer<{ $align?: 'left' | 'right' }>`
  position: fixed;
  bottom: var(--sticky-footer-offset-bottom, ${layout.mobileNavHeight});
  left: 0;
  right: 0;
  background: ${semantic.bg.canvas};
  border-top: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  padding: ${space['space-300']} ${space['space-500']};
  display: flex;
  align-items: center;
  justify-content: ${({ $align }) => ($align === 'right' ? 'flex-end' : 'space-between')};
  gap: ${space['space-600']};
  z-index: 103;
  width: 100%;
  box-sizing: border-box;

  @media (min-width: ${layout.desktopBreakpoint}) {
    position: sticky;
    bottom: 0;
    left: auto;
    right: auto;
    z-index: 10;
    width: auto;
    align-self: stretch;
    margin-top: ${space['space-600']};
    padding: ${space['space-600']} ${space['space-1000']};
  }
`;

export const FooterSpacer = styled.div`
  height: var(--sticky-footer-height, ${primitives.size['size-2000']});
  flex-shrink: 0;

  @media (min-width: ${layout.desktopBreakpoint}) {
    display: none;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FooterTitle = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const FooterTotal = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const FooterOriginalPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.tertiary};
  text-decoration: line-through;
`;

export const FooterDiscountedPrice = styled.span`
  font-family: ${bodyFont};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const FooterPriceRow = styled.span`
  display: inline-flex;
  align-items: baseline;
  gap: ${space['space-200']};
`;
